/*
 * Queue messages until iframe is loaded and listening to ipc messages.
 *
 * Implemented as Visitor pattern.
 *
 * Fix: Defer messages to work properly on ios.
 * Fix2: We queue messages until we make sure that the iframe content has
 * loaded.
 */
import { IpcInstance } from './ipc';

export interface Emitter<TPayload> {
  accept: (instance: IpcInstance<TPayload>) => void;
  send: (payload: TPayload) => void;
}

export function createEmitter<TPayload>() {
  let ipc: IpcInstance<TPayload> | undefined = undefined;
  const queue: TPayload[] = [];

  function send(payload: TPayload) {
    if (ipc) {
      /*
       * First message gets lost on ios locally, so defer it  (as per research
       * of Mariusz).
       */
      setTimeout(() => {
        ipc!.send(payload);
      }, 0);
    } else {
      queue.push(payload);
    }
  }

  function flush() {
    queue.forEach(payload => ipc!.send(payload));
  }

  /*
   * Call accept first when the iframe content has loaded.
   */
  function accept(_ipc: IpcInstance<TPayload>) {
    ipc = _ipc;
    flush();
  }

  return {
    accept,
    send,
  };
}
